module.exports = __webpack_public_path__ + "static/media/chat-pdf.8f0cd040.png";